import { ReactNode } from "react";
import { Coupon } from "types/Coupons";


interface ICouponListElementProps {
  coupon: Coupon;
  children?: ReactNode
}

export function CouponListElement(
  {
    coupon,
    children
  }: ICouponListElementProps
) {
  return (
    <div
      key={ coupon.coupon_code }
      className="flex items-center gap-2 p-3 bg-neutral-50 border border-neutral-50 dark:rounded"
    >
      <span className="font-medium dark:rounded-sm text-white bg-neutral-600 whitespace-nowrap px-1.5">{ coupon.coupon_code }</span>
      <span className="flex-1">{ coupon.coupon_name }</span>
      { children }
    </div>
  )
}
